import { render, staticRenderFns } from "./FlowPublicDetail.vue?vue&type=template&id=d72d50e2&scoped=true"
import script from "./FlowPublicDetail.vue?vue&type=script&lang=js"
export * from "./FlowPublicDetail.vue?vue&type=script&lang=js"
import style0 from "./FlowPublicDetail.vue?vue&type=style&index=0&id=d72d50e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72d50e2",
  null
  
)

export default component.exports